import fetch from 'cross-fetch';
import { hasuraGqlUrl, hasuraAdminKey } from '../../config';
import { getp } from '../../helpers/getProp';
import { signAnonJWT } from '../auth/jwtUtils';

export default async function queryHasura(query, variables, token, operationName, isAdmin) {
  console.log('hasura query start', operationName, variables);
  const body = {
    query,
    variables,
  };
  if (operationName) body.operationName = operationName;
  const fetchArgs = {
    body: JSON.stringify(body),
    method: 'POST',
  };
  if (!token) {
    token = signAnonJWT();
  }
  fetchArgs.headers = {
    Authorization: 'Bearer ' + token,
  };

  if (isAdmin) {
    fetchArgs.headers = {
      'X-Hasura-admin-secret': hasuraAdminKey,
    };
  }
  let result;
  let resultBody;
  // console.log('fetchArgs', hasuraGqlUrl, fetchArgs);
  try {
    result = await fetch(hasuraGqlUrl, fetchArgs);
  } catch (err) {
    console.log('queryHasura -> err fetch', err);
  }
  try {
    resultBody = await result.json();
  } catch (err) {
    console.log('queryHasura -> err json', err);
  }
  // console.log('hasura result', operationName, JSON.stringify(resultBody));
  return resultBody;
}



// WEBPACK FOOTER //
// ./src/core/fetch/queryHasura.js